import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  getGmails,
  getGmailsFailure,
  getGmailsSuccess,
} from './google.actions';
import { GoogleService } from 'src/app/services/google.service';

@Injectable()
export class GoogleEffects {
  getGmails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getGmails),
      switchMap(({ email, page }) =>
        this.googleService.getGmails(email, page).pipe(
          map((response) => {
            if (!response || !response.data) {
              // If the response object is not structured as expected, throw an error
              throw new Error('Invalid gmail response');
            }
            // console.log('All searches successful', response.searches);
            return getGmailsSuccess({ new_gmails: response.data });
          }),
          catchError((error) => {
            console.log('Get Gmails failed', error);
            return of(getGmailsFailure({ error }));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private googleService: GoogleService
  ) {}
}
